import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {
    TypographyPreviewComponent,
    TypographyPreviewModel
} from "@white-label/components/white-label/typography-preview/typography-preview.component";
import {DynamicScaleDirective} from "@cybfed/core/utils/dynamic-scale.directive";
import {customSetTimeout} from "@cybfed/core/helpers/overrided-timers";
import {EventService} from "@cybfed/core/store/event.service";


export class NotificationWidgetDesignModel {
    duration = 10;
    format = "";
    fromAmount = 10;
    mediaUrl = "/assets/image/emailLogo.png";
    message = new TypographyPreviewModel();
    onlyEquals = true;
    positioning = "text-right";
    isVideoNotification = false;
    soundDelay = 10;
    soundVoice = 10;
    status = "active";
    title = new TypographyPreviewModel();
    voiceUrl = "";
}

@Component({
    selector: 'white-label-notification-ad-render',
    templateUrl: './notification-ad-render.component.html',
    styleUrl: './notification-ad-render.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        TypographyPreviewComponent,
        DynamicScaleDirective
    ]
})
export class NotificationAdRenderComponent implements OnInit, OnChanges, OnDestroy {
    changesCount = 0;
    @Input() notificationDesign: any = new NotificationWidgetDesignModel();
    @ViewChild('videoElement') videoElement: any;
    @Input() createMode: any = false;
    @Input() notificationData: any = {
        username: 'John Doe',
        amount: '$100',
        message: 'some amazing message from John Doe'
    };
    showMessageString = '';
    @Output() onEnd = new EventEmitter();
    rerenderFlag = true;
    audioPlayer: any;
    videoPlayer: any;
    timeoutSound:any;
    showAll = false;

    constructor(private eventManager: EventService) {
    }

    ngOnInit() {
        if (this.notificationDesign?.voiceUrl && !this.createMode && !this.notificationDesign.isVideoNotification) {
            this.playSound();
        } else if(this.notificationDesign.isVideoNotification){
            this.videoPlayer = document.getElementById('videoPlayer');
        }

        if(this.createMode){
            this.showAll = true;
        }
        this.eventManager.rescaleDone.subscribe(()=>{
            this.showAll = true;
            if(this.videoPlayer){
                this.videoPlayer.play();
            }
        })
        setTimeout(() => {
            this.onEnd.emit()
        }, this.notificationDesign?.duration * 1000);
    }

    ngOnChanges(changes: SimpleChanges): void {
        //this.showAll = false;
        this.rerender();
    }


    // Plays the notification sound after the specified delay.
    playSound() {
        if(this.timeoutSound){
            clearTimeout(this.timeoutSound);
        }
        this.timeoutSound = customSetTimeout(() => {
            this.audioPlayer = new Audio(this.notificationDesign.voiceUrl);
            this.audioPlayer.volume = Math.min(this.notificationDesign.soundVoice / 100, 1);
            this.audioPlayer.play().catch(err => console.error('Error playing audio:', err));
        }, this.notificationDesign.soundDelay * 1000);
    }


    rerender(){
        this.showMessageString =
            this.notificationDesign?.format
                ?.replace('{username}', this.notificationData.username || 'Anonymous')
                ?.replace('{amount}', this.notificationData.amount || '');
        if(this.timeoutSound){
            clearTimeout(this.timeoutSound);
        }
        if(this.audioPlayer){
            this.audioPlayer.currentTime = 0
            this.audioPlayer.pause();
        }
        this.rescale()
        this.rerenderFlag = false;
        customSetTimeout(() => {
            this.rerenderFlag = true;
        })
        // if(this.createMode){
        //     this.showAll = true;
        // }

    }

    ngOnDestroy(): void {
        if(this.timeoutSound){
            clearTimeout(this.timeoutSound);
        }
        if(this.audioPlayer){
            this.audioPlayer.currentTime = 0;
            this.audioPlayer.pause();
        }

        if(this.videoPlayer){
            this.videoPlayer?.stop();
        }
    }

    rescale(){
        this.showAll = false;
        this.eventManager.rescale.emit();
    }
}
